import { useSelector } from 'react-redux';
import { MapGeneric } from '../mapGeneric/MapGeneric';
import { useToasts } from '@lightspeed/flame/Toaster';
import { useTranslation } from 'react-i18next';
import useAccounts from '../../hooks/useAccounts';
import useConnectionMode from '../../hooks/useConnectionMode';
import { getCurrentTarget } from '../../utils/helpers/commonHelpers';
import { getDiscountsList } from '../../redux/api/advancedConfig';
import useLocation from '../../hooks/useLocation';

export const IndividualDifferences = (props) => {
  const { isChangedPostingMethod } = useSelector(state => state.forms.meta);
  const fetchedMapping = isChangedPostingMethod ? null : props.location.state.fetchedMapping;
  const location = useLocation();
  const { addToast } = useToasts();
  const [, accountsList] = useAccounts('discount');
  const { defaultDiffAccount: defaultAccountValue } = useSelector(state =>
    state.forms.entities.dashboard?.values
  ) || {};
  const placeholderAccount = defaultAccountValue && accountsList.find(account => (account.value === defaultAccountValue));
  const placeholder = placeholderAccount && placeholderAccount.label;
  const [, softwareName] = useConnectionMode();

  const target = getCurrentTarget();
  const { t } = useTranslation();

  const config = [
    {
      title: t('LsDifferences', { target: target.fullName }),
      name: 'diff',
    },
    {
      title: t('SwFloatDiffAccount', { swName: softwareName }),
      name: 'account',
      options: accountsList,
      type: 'dropdown',
      placeholder: placeholder,
    }
  ];

  const handleError = (res, msgArg) => {
    let msg = msgArg || t('Fetch failure');

    if (res && res.data && res.data.message) {
      msg = res.data.message.errorMessage || msg;
    }
    addToast(msg, { appearance: 'error' });
  };

  const fetchRows = () => {
    return getDiscountsList(location.id).then(res => {
      let rowsList;
      if (res.data) {
        const resData = res.data;
        rowsList = resData.map(rowInfoRaw => {
          const formValues = {
            [config[0].name]: rowInfoRaw.name,
            [config[1].name]: (fetchedMapping && fetchedMapping[rowInfoRaw.id]) || '',
            id: rowInfoRaw.id,
          };

          return formValues;
        });

        return rowsList;
      } else {
        handleError(res);
      }
    }).catch(err => {
      handleError(err.response);
    });
  };

  return <>
    <MapGeneric
      pageTitle="Map float differences"
      pageDescription={t('FloatDiffPageDescription', { swName: softwareName })}
      title={t('Float differences')}
      description={t('FloatDiffDescription', { swName: softwareName })}
      config={config}
      fetchRows={fetchRows}
      name="differencesMapping"
      persistFormName="differencesMapping"
      {...props}
    />
  </>;
};
